import * as yup from "yup"

export const validationSchema = yup.object().shape({
    mr_group_id: yup.number().label("Group asset").required(),
    mr_brand_code: yup.string().label("Brand code").required().min(2).max(3),
    mr_brand_name: yup.string().label("Brand name").required().max(100, "Must be 100 characters or less"),
    description: yup.string().optional()
})